import api from "@/router/api";

export default {
  async getEncontroImagemByEncontroId(encontroId, page = 0, size = 10) {
    const response = await api.get(`/encontro-imagem/${encontroId}`, {
      params: { page, size },
    });
    return response.data;
  },

  async getEncontroImagemPublicaByEncontroId(encontroId, page = 0, size = 10) {
    const response = await api.get(`/encontro-imagem/${encontroId}/publicas`, {
      params: { page, size },
    });
    return response.data;
  },

  async getEncontroImagemByAcaoId(acaoId, page = 0, size = 10) {
    const response = await api.get(`/encontro-imagem/acao/${acaoId}`, {
      params: { page, size },
    });
    return response.data;
  },

  async getEncontroImagemPublicaByAcaoId(acaoId, page = 0, size = 10) {
    const response = await api.get(`/encontro-imagem/acao/${acaoId}/publicas`, {
      params: { page, size },
    });
    return response.data;
  },

  async getEncontroImagemById(encontroImagemId) {
    const response = await api.get(
      `/encontro-imagem/imagem/${encontroImagemId}`
    );
    return response.data;
  },

  async getEncontroImagemPublica(page = 0, size = 10 , listagemAleatoria = false) {
    const response = await api.get(`/encontro-imagem/publicas`, {
      params: { page, size, listagemAleatoria},
    });
    return response.data;
  },

  async postEncontroImagem(encontroId, imagemData) {
    const response = await api.post(
      `/encontro-imagem/${encontroId}`,
      imagemData
    );
    return response.data;
  },

  async postLoteEncontroImagem(encontroId, imagensData) {
    const response = await api.post(
      `/encontro-imagem/lote/${encontroId}`,
      imagensData
    );
    return response.data;
  },
  
  async modificarVisibilidadeEncontroImagem(encontroImagemId, isPublica) {
    const response = await api.patch(`/encontro-imagem/imagem/${encontroImagemId}`, isPublica);
    return response.data;
  },

  async deleteEncontroImagem(encontroImagemId) {
    const response = await api.delete(
      `/encontro-imagem/imagem/${encontroImagemId}`
    );
    return response.data;
  },
};
